import React, { useState } from "react";
import {
    IconButton,
    TextField,
    InputAdornment,
    Box
} from "@mui/material";
import {
    Search as SearchIcon,
    Clear as ClearIcon
} from "@mui/icons-material";


const ExpandableSearch = ({ value, onChange, expandedWidth = 150 }) => {
    const [expanded, setExpanded] = useState(false);

    const handleClear = () => {
        onChange("");
        setExpanded(false);
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                transition: "width 0.3s ease",
                width: expanded ? expandedWidth : 40,
                overflow: "hidden",
            }}
        >
            {expanded ? (
                <TextField
                    autoFocus
                    fullWidth
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={() => {
                        if (!value) setExpanded(false);
                    }}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            paddingTop: 0.5,
                            paddingBottom: 0.5,
                            paddingRight: 0.5,
                        },
                        "& .MuiOutlinedInput-input": {
                            padding: "4px 2px",
                        },
                        transition: "width 0.3s ease",
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" sx={{ color: "text.secondary" }} />
                            </InputAdornment>
                        ),
                        endAdornment: value && (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={handleClear}
                                    edge="end"
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            ) : (
                <IconButton onClick={() => setExpanded(true)}>
                    <SearchIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default ExpandableSearch;
